import { useForm } from "react-hook-form";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";
import CustomInput from "../../../../components/UI/PageInput/CustomInput";
import SearchDropdown from "../../../../components/UI/PageInput/SearchDropdown";
import SiteViewDialog from "../../dialog/SiteViewDialog";
import { CirclePlus } from "lucide-react";
import PrimaryButton from "../../../../components/UI/buttonUI/PrimaryButton";
import { ADD_SITE } from "../../apiEndpoints";
import usePostData from "../../../../CustomHooks/useAxios/usePostData";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import { siteNameValidation } from "../../../../validations/formValidations";

const AddSIngleSiteForm = ({ siteSetup }) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
    reset,
  } = useForm();

  const {
    executePost,
    loading,
    formError,
    successResponse,
    setFormError,
    setSuccessResponse,
  } = usePostData();

  const onSubmit = (data) => {
    const formValues = {
      ...data,
      isAutomation: false,
    };
    executePost(formValues, ADD_SITE, reset);
  };

  return (
    <>
      {formError && (
        <ErrorDisplay
          message={formError}
          closeAction={() => setFormError("")}
        />
      )}
      <form onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}>
        <div className="flex flex-wrap">
          <div className="halfCol">
            <div className="px-1">
              <CustomInput
                type="text"
                name="name"
                labelText="Site Name *"
                placeholder="Enter"
                register={{
                  ...register("name", {
                    ...siteNameValidation,
                    required: "Please enter a site name",
                  }),
                }}
                error={errors.name}
              />

              <SearchDropdown
                name="jbccFt"
                label="Field Technician (JBCC) *"
                keyName="fullName"
                id="id"
                options={siteSetup.jbccFieldTechnicians}
                setValue={setValue}
                control={control}
                selectedVal={watch("jbccFt")}
                error={errors.jbccFt}
                search={true}
              />
              <SearchDropdown
                name="jeId"
                label="JE Name *"
                keyName="name"
                id="id"
                options={siteSetup.jes}
                setValue={setValue}
                control={control}
                selectedVal={watch("jeId")}
                error={errors.jeId}
                search={true}
                showOptionId={true}
              />
            </div>
          </div>
          <div className="halfCol">
            <div className="px-1">
              <SearchDropdown
                name="stationCategoryId"
                label="Site Category *"
                keyName="name"
                id="id"
                options={siteSetup.categories}
                setValue={setValue}
                control={control}
                selectedVal={watch("stationCategoryId")}
                error={errors.stationCategoryId}
                search={true}
              />
              <SearchDropdown
                name="jnFt"
                label="Field Technician (JN) *"
                keyName="fullName"
                id="id"
                options={siteSetup.jnFieldTechnicians}
                setValue={setValue}
                control={control}
                selectedVal={watch("jnFt")}
                error={errors.jnFt}
                search={true}
              />
            </div>
          </div>
        </div>
        <div className="addBtn---wrap">
          <p className="addWrap">
            <PrimaryButton
              btnText={!loading ? "Add Site" : "Adding..."}
              loading={loading}
              Icon={CirclePlus}
              size={18}
            />
          </p>
          <p className="grayWrap">
            <GrayButton btnText="Clear" onClick={() => reset()} />
          </p>
        </div>
      </form>
      {successResponse && (
        <SiteViewDialog
          viewDetails={successResponse}
          successView={true}
          setSiteViewDetails={setSuccessResponse}
          successMsg="Site Successfully created!"
        />
      )}
    </>
  );
};
export default AddSIngleSiteForm;
